export default __webpack_public_path__ + "static/media/person-chairman3.f94e7ad7.png";